// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__VDo5X","teams":"Search_teams__df9Iw","dropdown":"Search_dropdown__nf-qv"};